(function () {
  const bar = document.getElementById('sticky-atc-bar');
  const triggerElement = document.getElementById('product_form_butts');
  const variantPicker = document.getElementById('product_form_variants');
  const addToCartSection = document.getElementById('product_form_butts'); // same as trigger

  if (!bar || !triggerElement) return;

  // --- IntersectionObserver: show/hide bar ---
  // const observer = new IntersectionObserver(
  //   ([entry]) => {
  //     bar.classList.toggle('is-visible', !entry.isIntersecting);
  //     bar.setAttribute('aria-hidden', String(entry.isIntersecting));
  //   },
  //   { threshold: 0, rootMargin: '-100px 0px 0px 0px' }
  // );
  // observer.observe(triggerElement);

  const observer = new IntersectionObserver(
    ([entry]) => {
      // Only show when element has scrolled past the TOP of viewport
      const isPastTop = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      bar.classList.toggle('is-visible', isPastTop);
      bar.setAttribute('aria-hidden', String(!isPastTop));
    },
    { threshold: 0 }  // removed rootMargin so it fires at the exact edge
  );
  observer.observe(triggerElement);

  // Helper: detect mobile viewport
  function isMobile() {
    return window.innerWidth <= 767; // adjust breakpoint as needed
  }

  // Sticky button click: scroll to appropriate element
  const stickyBtn = document.getElementById('sticky-atc-submit');
  if (stickyBtn) {
    stickyBtn.addEventListener('click', (e) => {
      e.preventDefault();
      
      let targetElement;
      if (isMobile()) {
        // On mobile: scroll to the Add to Cart button section
        targetElement = addToCartSection;
      } else {
        // On desktop: scroll to variant picker
        targetElement = variantPicker;
      }
      
      if (targetElement) {
        targetElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } else if (variantPicker) {
        // Fallback to variant picker if mobile target missing
        variantPicker.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });
  }
})();